document.addEventListener('bundler:loaded', function (e) {
  //console.log('get budlez', window.bndlr.getBundles());
  const activeBundles = window.bndlr.getBundles();

  let volumeDiscounts = [];
  let currentBundle = null;
  let currentProductHandle = document.querySelector('[data-product-handle]').getAttribute('data-product-handle');

  activeBundles.forEach((bundle) => {
    if (bundle.is_volume_bundle === 'true' && bundle.volume_discounts && bundle.volume_discounts.length > 0) {
      // Check if the current product is in this volume discount bundle
      const bundleProduct = Object.values(bundle.products).find((p) => p.handle === currentProductHandle);
      if (bundleProduct) {
        console.log('Volume discount bundle found for current product', bundle);
        volumeDiscounts = bundle.volume_discounts;
      }
    }
  });

  function getDiscountedPrice(quantity, originalPrice) {
    console.log('Original price:', originalPrice);
    console.log('Quantity:', quantity);
    console.log('Volume discounts:', volumeDiscounts);

    for (let i = volumeDiscounts.length - 1; i >= 0; i--) {
      if (quantity >= volumeDiscounts[i].min_items) {
        const discountValue = parseFloat(volumeDiscounts[i].discount_value);
        console.log('Applying discount:', volumeDiscounts[i]);
        if (volumeDiscounts[i].discount_type === 'percentage') {
          const discountedPrice = originalPrice * (1 - discountValue / 100);
          console.log('Discounted price (percentage):', discountedPrice);
          return discountedPrice;
        } else if (volumeDiscounts[i].discount_type === 'fixed_amount') {
          const discountedPrice = Math.max(0, originalPrice - discountValue);
          console.log('Discounted price (fixed amount):', discountedPrice);
          return discountedPrice;
        }
      }
    }
    console.log('No discount applied');
    return originalPrice;
  }

  const crossselling = document.querySelectorAll('.crossselling-product');
  const addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]');
  const currentPriceElement = document.querySelector('.current-price');
  const comparePriceElement = document.querySelector('.compare-at-price');
  const variantSelectors = document.querySelectorAll('.variant-selector');

  let additionalPrice = 0;
  let additionalComparePrice = 0;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    // Fallback formatting if Shopify.formatMoney is not available
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateTotalPrice() {
    if (!currentPriceElement) return;
    let basePrice = parseFloat(currentPriceElement.getAttribute('data-solo-price'));
    let baseComparePrice = comparePriceElement
      ? parseFloat(comparePriceElement.getAttribute('data-base-compare-price'))
      : null;
    let quantity = parseInt(document.querySelector(`[data-type="add-to-cart-form"] [name="quantity"]`).value) || 1;

    console.log(additionalPrice);

    let totalPrice = basePrice * quantity + additionalPrice;
    let totalComparePrice = baseComparePrice ? baseComparePrice * quantity + additionalComparePrice : null;

    const discountedPrice = getDiscountedPrice(quantity, totalPrice);

    if (discountedPrice > 0) {
      currentPriceElement.innerHTML = formatMoney(discountedPrice);
      currentPriceElement.setAttribute('data-price', discountedPrice);
    }

    if (comparePriceElement && totalComparePrice !== null) {
      comparePriceElement.innerHTML = formatMoney(totalComparePrice);
      comparePriceElement.setAttribute('data-compare-price', totalComparePrice);
      comparePriceElement.style.display = totalComparePrice > totalPrice ? 'none' : 'none';
    }

    // Update price difference display
    const priceDifferenceElement = document.querySelector('.price-difference');
    if (priceDifferenceElement && totalComparePrice !== null) {
      const priceDifference = totalComparePrice - totalPrice;
      if (priceDifference > 0) {
        priceDifferenceElement.textContent = `Diese woche ${formatMoney(priceDifference)} rabatt`;
        priceDifferenceElement.style.display = 'block';
      } else {
        priceDifferenceElement.style.display = 'none';
      }
    }
  }

  crossselling.forEach(function (product) {
    const checkbox = product.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        const price = parseFloat(product.querySelector('[data-product-price]').getAttribute('data-product-price'));
        if (checkbox.checked) {
          additionalPrice += price;
          additionalComparePrice += price;
        } else {
          additionalPrice -= price;
          additionalComparePrice -= price;
        }
        updateTotalPrice();
      });
    }
  });

  document.addEventListener('variant:changed', function (event) {
    console.log('changed');
    const variant = event.detail.variant;

    if (!variant) return false;

    if (currentPriceElement) {
      currentPriceElement.setAttribute('data-solo-price', variant.price);
    }
    if (comparePriceElement) {
      comparePriceElement.setAttribute('data-compare-price', variant.compare_at_price || variant.price);
    }
    additionalPrice = 0;
    additionalComparePrice = 0;
    crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = false;
      }
    });
    //updateTotalPrice();
  });

  // Listen for calculator updates
  document.addEventListener('calculator:updated', function (event) {
    //updateTotalPrice();
  });

  variantSelectors.forEach((selector) => {
    selector.addEventListener('change', function () {
      additionalPrice = 0;
      crossselling.forEach(function (product) {
        const checkbox = product.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = false;
        }
      });
      updateTotalPrice();
    });
  });

  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (event) {
      event.preventDefault();

      let items = '';
      const formData = new FormData(addToCartForm);
      const mainProductId = formData.get('id');
      const mainProductQuantity = formData.get('quantity');
      const mainProductProperties = formData.get('properties[Bedrukte tekst]');

      if (mainProductProperties !== null) {
        items = [
          {
            id: mainProductId,
            quantity: parseInt(mainProductQuantity, 10),
            properties: {
              'Bedrukte tekst': mainProductProperties,
            },
          },
        ];
      } else {
        items = [
          {
            id: mainProductId,
            quantity: parseInt(mainProductQuantity, 10),
          },
        ];
      }

      crossselling.forEach(function (product) {
        const checkbox = product.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          const variantId = checkbox.getAttribute('data-variant-id');
          items.push({
            id: variantId,
            quantity: 1,
          });
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Success:', data);
          window.location.href = '/cart';
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  }

  // Initial update
  //updateTotalPrice();
});
